import React, { Component } from 'react';

export class NotConnectTalkPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const RenderMultiElement = () => [
      <div id="kakaoHead" className="head_bridge" role="banner" key="header">
        <h1 className="tit_logo">
          <a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>,
      <hr className="hide" key="hidden_line" />,
      <div id="kakaoContent" className="cont_bridge" role="main" key="content">
        <span className="img_404" />
        <strong className="tit_bridge">이 계정과 연결된 카카오톡이 없습니다.</strong>
        <p className="desc_bridge">모바일 카카오톡에 연결된 카카오계정을<br />확인한 후 다시 시도해주세요.</p>
        <div className="logout_bridge">
          <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
            className="link_logout"
          >
            로그아웃
          </a>
        </div>
      </div>
    ];
    return (<RenderMultiElement />);
  }
}

export default NotConnectTalkPage;



// WEBPACK FOOTER //
// ./src/containers/NotConnectTalkPage/index.js